import PageLoadAnimation from "../page-load-animation";

class AsyncShippingChecks {
	constructor(el) {
		this._init(el)
	}

	_init(el) {
		// this.el = document.querySelector('[data-async-shipping]')
		if(el) {
			this.el = el
		} else {
			this.el = document.querySelector('[data-shipping-method]')
		}
		if(!this.el) {
			return
		}

		// console.log('ship Init')

		this.elForm = document.querySelector('[data-shipping-method]')
		if(!this.elForm)
		{
			return
		}

		this.fetchURL = this.elForm.dataset.shippingMethod
		this.elError = this.elForm.querySelector('[data-field-error]')

		this.loading = new PageLoadAnimation(false)

		this.elActions = this.el.querySelectorAll('[data-shipping-method-element]')
		this.elActions.forEach(el => {
			el.shippingID = this.getElActionId(el)
		})
	}

	runChecks() {
		return new Promise((resolve, reject) => {
			this.setLoadingAnimation(true)
			let id = null
			let promises = []
			this.elActions.forEach(el => {
				if(el.checked) {
					id = this.getElActionId(el)
					promises.push(this.setShippingMethod(id))
				}
			})
			Promise.all(promises)
				.then(result => {
					let elSum, elShipFill
					if(elShipFill = document.querySelector('[data-ship]')) {
						elShipFill.shipFill.updateValue()
					}
					if(elSum = document.querySelector('[data-sum]')) {
						elSum.sum.calculate()
					}
					resolve(result)
				})
				.catch(error => {
					for(let i = 0; i < error.length; i++) {
						if(!this.elForm) {
							return
						}
						if(json[i]['error'])
						{
							this.elForm.classList.add('field-is-invalid')
							this.elError.innerHTML = json[i]['error']
						}
					}
					reject(error)
				})
		})
		.finally(() => {
			this.setLoadingAnimation(false)
		})
	}

	setShippingMethod(id) {
		let json = JSON.stringify({
			'shipping-id': id
		})
		// console.log(window.location.origin + this.fetchURL)
		return fetch(window.location.origin + this.fetchURL
		,{
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: json,
		}
		).then(response => response.json())
	}

	getElActionId(el) {
		return el.getAttribute('id').split('-').pop()
	}

	setLoadingAnimation(on) {
		if(this.loading && this.loading.promiseInit()) {
			this.loading.toggleLoading(on)
		}
		else {
			this.loading = null;
		}
	}
}

export default AsyncShippingChecks